export default "__VITE_ASSET__BEk9DrRE__"